import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Logger } from 'src/app/common/utility/logger/logger';

export enum MB_TYPE {
  OK,
  YES_NO,
  RETRY_CANCEL
}

export enum MB_RESPONSE {
  OK = 'ok',
  YES = 'yes',
  NO = 'no',
  CANCEL = 'cancel',
  RETRY = 'retry'
}

export interface MessageBoxOptions {
  type: MB_TYPE | undefined;
  title: string | undefined;
  message: string;
}

interface MessageBox {
  type: MB_TYPE,
  button1Label: string,
  button1Response: MB_RESPONSE,
  button2Label?: string | undefined,
  button2Response?: MB_RESPONSE | undefined,
  button3Label?: string | undefined,
  button3Response?: MB_RESPONSE | undefined
}

const messageBox: Array<MessageBox> = [
  {
    type: MB_TYPE.OK,
    button1Label: "global.button.ok", button1Response: MB_RESPONSE.OK
  },
  {
    type: MB_TYPE.YES_NO,
    button1Label: "global.button.yes", button1Response: MB_RESPONSE.YES,
    button2Label: "global.button.no", button2Response: MB_RESPONSE.NO
  },
  {
    type: MB_TYPE.RETRY_CANCEL,
    button1Label: "global.button.retry", button1Response: MB_RESPONSE.RETRY,
    button2Label: "global.button.cancel", button2Response: MB_RESPONSE.CANCEL,
  },
]

@Component({
  selector: 'ems-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnInit {
  currentMessageBox: MessageBox | undefined;

  constructor(
    public dialogRef: MatDialogRef<MessageBoxComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public messageBoxSettings: MessageBoxOptions
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    // Set the message box info
    this.currentMessageBox = messageBox.find((msgbox) => msgbox.type === this.messageBoxSettings.type)
    if (!this.currentMessageBox) {
      Logger.error(`MessageBox not found ${JSON.stringify(this.messageBoxSettings)}`);
      return;
    }
  } // ngOnInit()

  public isTitleSet(): boolean {
    return (!!this.messageBoxSettings.title)
  }

  public get getTitle(): string {
    if (this.messageBoxSettings.title)
      return this.messageBoxSettings.title;
    return '';
  } // getTitle()

  public get getMessage() {
    return this.messageBoxSettings.message;
  } // getMessage()

  public get isButton1Enabled(): boolean {
    return (this.currentMessageBox?.button1Label !== undefined)
  }

  public get isButton2Enabled(): boolean {
    return (this.currentMessageBox?.button2Label !== undefined)
  }

  public get isButton3Enabled(): boolean {
    return (this.currentMessageBox?.button3Label !== undefined)
  }

  public get button1Label(): string {
    return this.currentMessageBox?.button1Label ? this.currentMessageBox?.button1Label : ''
  }

  public get button2Label(): string {
    return this.currentMessageBox?.button2Label ? this.currentMessageBox?.button2Label : ''
  }

  public get button3Label(): string {
    return this.currentMessageBox?.button3Label ? this.currentMessageBox?.button3Label : ''
  }

  public button1Clicked() {
    { this.dialogRef.close({ event: this.currentMessageBox?.button1Response }); }
  }

  public button2Clicked() {
    { this.dialogRef.close({ event: this.currentMessageBox?.button2Response }); }
  }

  public button3Clicked() {
    { this.dialogRef.close({ event: this.currentMessageBox?.button3Response }); }
  }

}
